import React, { useState, useEffect } from 'react';

const SearchDataForm = ({requestData, onBerechnenButton}) => {

  const {kaufpreis, vorhaben, eigenmittel, laufzeit} = requestData;
  const [lzInput, setLzInput] = useState(laufzeit);
  const [kaufpreisInput, setkaufpreisInput] = useState(kaufpreis);
  const [vorhabenInput, setVorhabenInput] = useState(vorhaben);
  const [eigenmittelInput, setEigenmittelInput] = useState(eigenmittel);

  // Synchronisierung mit requestData
  useEffect(() => {
    setkaufpreisInput(requestData.kaufpreis);
    setEigenmittelInput(requestData.eigenmittel);
    setLzInput(requestData.laufzeit);
    setVorhabenInput(requestData.vorhaben);
  }, [requestData]);

  const formatNumber = (value) => {
    if (value === '' || value == null) return '';
    return new Intl.NumberFormat('de-DE').format(value);
  };

  const parseNumber = (value) => {
    return value.replace(/\./g, '').replace(',', '.');
  };

  const handleKaufpreisChange = (e) => {
    const rawValue = parseNumber(e.target.value);
    if (!isNaN(rawValue)) setkaufpreisInput(Number(rawValue));
  };

  const handleEigenmittelChange = (e) => {
    const rawValue = parseNumber(e.target.value);
    if (!isNaN(rawValue)) setEigenmittelInput(Number(rawValue));
  };

  const handleBerechnenClick = (e) => {
    e.preventDefault();
    const data = {
      kaufpreis: Number(kaufpreisInput),
      laufzeit: Number(lzInput),
      vorhaben: Number(vorhabenInput),
      eigenmittel: Number(eigenmittelInput),
    };
    onBerechnenButton(data);
  };

  return (
    <form className="search-data-form" onSubmit={handleBerechnenClick}>
      <div className="row g-2">
        <div className="col-md">
          <div className="form-floating mb-3">
            <input
              id="kaufpreisInputField"
              type="text"
              inputMode="numeric"
              value={formatNumber(kaufpreisInput)}
              className="form-control"
              onChange={handleKaufpreisChange}
              placeholder="Kaufpreis"
            />
            <label htmlFor="kaufpreisInputField">Kaufpreis</label>
          </div>
        </div>

        <div className="col-md">
          <div className="form-floating mb-3">
            <input
              id="eigenmittelInputField"
              type="text"
              inputMode="numeric"
              value={formatNumber(eigenmittelInput)}
              className="form-control"
              onChange={handleEigenmittelChange}
              placeholder="Eigenmittel"
            />
            <label htmlFor="eigenmittelInputField">Eigenmittel</label>
          </div>
        </div>

        <div className="col-md">
          <div className="form-floating mb-3">
            <select
              id="lzInputField"
              value={lzInput}
              className="form-control"
              onChange={(e) => setLzInput(e.target.value)}
              placeholder="Laufzeit"
            >
              <option value="420">35 Jahre</option>
              <option value="360">30 Jahre</option>
              <option value="300">25 Jahre</option>
              <option value="240">20 Jahre</option>
              <option value="180">15 Jahre</option>
              <option value="120">10 Jahre</option>
            </select>
            <label htmlFor="lzInputField">Laufzeit</label>
          </div>
        </div>

        <div className="col-md">
          <div className="form-floating mb-3">
            <select
              id="vorhabenInputField"
              value={vorhabenInput}
              className="form-control"
              onChange={(e) => setVorhabenInput(e.target.value)}
              placeholder="Vorhaben"
            >
              <option value="1">Hausbau</option>
              <option value="2">Hauskauf / Grundkauf</option>
              <option value="3">Eigentumswohnung</option>
              <option value="4">Genossenschaft</option>
            </select>
            <label htmlFor="vorhabenInputField">Vorhaben</label>
          </div>
        </div>

        <div className="col-md">
          <button type="submit" className="btn btn-primary btn-contact btn-calc">
            JETZT BERECHNEN
          </button>
        </div>
      </div>
    </form>
  );
};

export default SearchDataForm;
